// extracted by mini-css-extract-plugin
export var $animation_name = "RichTextWide-module--$animation_name--998dd";
export var Links = "RichTextWide-module--Links--5c39f";
export var RichText = "RichTextWide-module--RichText--31c09";
export var RichText___christmas = "RichTextWide-module--RichText___christmas--d5a0a";